/**
 * Custom application routes
 *
 * Extends the auto-generated routes with custom routes
 */

import { coreRoutes } from './core.custom';
import { inventoryRoutes } from './inventory.generated';
import { salesRoutes } from './sales.custom';
import { taskmanagementRoutes } from './taskmanagement.custom';
import { workflowRoutes } from './workflow.generated';
import { integrationRoutes } from './integration.generated';
import { procurementRoutes } from './procurement.generated';
import { financeRoutes } from './finance.custom';
import { pricingRoutes } from './pricing.generated';
import { forestryRoutes } from './forestry.custom';
import { setupFlowRoutes } from './setupFlows.generated';

/**
 * All application routes
 * Combined from all module routes (including custom extensions)
 */
export const appRoutes = [
  ...coreRoutes,
  ...inventoryRoutes,
  ...salesRoutes,
  ...taskmanagementRoutes,
  ...workflowRoutes,
  ...integrationRoutes,
  ...procurementRoutes,
  ...financeRoutes,
  ...pricingRoutes,
  ...forestryRoutes,
  ...setupFlowRoutes,
];

